export default __webpack_public_path__ + "static/media/flag-anguilla.0742817c.svg";